import { useDraggable } from "@dnd-kit/core";
import { IDeclarantApplication } from "../../types";
import s from "./Card.module.scss";
import { getStatusTag } from "../../utils/functions";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { getApplicationDetails } from "../../redux/ApplicationSlice";
import { unwrapResult } from "@reduxjs/toolkit";

type TaskCardProps = {
  task: IDeclarantApplication;
};

export interface CustomDraggableArguments {
  id: string;
  status: string;
  owner_name: string;
  contract_number: string;
  application_number: string;
  created_at: string;
}

export function TaskCard({ task }: TaskCardProps) {
  const { t } = useTranslation();
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: task.id,
    status: task.status,
  } as CustomDraggableArguments);

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const titleStyle = {
    fontWeight: 500, // font-medium
    color: "#f5f5f5", // text-neutral-100
  };

  const descriptionStyle = {
    marginTop: "8px", // mt-2
    fontSize: "14px", // text-sm
    color: "#9ca3af", // text-neutral-400
  };

  const goToApplicationDetails = async (id: number) => {
    await dispatch(getApplicationDetails(id));

    navigate(`/application/${id}`);
  };

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={s.application}
      style={
        transform
          ? { transform: `translate(${transform.x}px, ${transform.y}px)` }
          : {}
      }
    >
      <div className={s.header}>
        <div className={s.title}>{task?.owner_name}</div>
        <div className={s.status}>{getStatusTag(task?.status, "sm", t)}</div>
      </div>

      <div className={s.contract_number}>
        {t("№ заявки")}: &nbsp;
        <div className={s.font}>{task?.application_number}</div>
      </div>

      <div className={s.bottom}>
        <div
          className={s.link}
          onClick={(e) => {
            e.stopPropagation();

            goToApplicationDetails(task?.id);
          }}
          onPointerDown={(e) => {
            e.stopPropagation();
          }}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              goToApplicationDetails(task?.id);
            }
          }}
        >
          {t("Просмотреть")}
        </div>

        <div className={s.date}>
          {moment(task?.created_at).format("DD.MM.YYYY")}
        </div>
      </div>
    </div>
  );
}
